"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var maxBy_1 = tslib_1.__importDefault(require("lodash/maxBy"));
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var util_1 = require("../util");
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var InputControl = /** @class */ (function (_super) {
    tslib_1.__extends(InputControl, _super);
    function InputControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputControl.prototype.render = function () {
        var _a = this.props, classNames = _a.classNames, description = _a.description, id = _a.id, errors = _a.errors, label = _a.label, uischema = _a.uischema, schema = _a.schema, visible = _a.visible, required = _a.required, path = _a.path, cells = _a.cells, config = _a.config;
        var isValid = errors.length === 0;
        var divClassNames = [classNames.validation]
            .concat(isValid ? classNames.description : classNames.validationError)
            .join(' ');
        var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        var labelText = core_1.isPlainLabel(label) ? label : label.default;
        var cell = maxBy_1.default(cells, function (r) { return r.tester(uischema, schema); });
        if (cell === undefined ||
            cell.tester(uischema, schema) === core_1.NOT_APPLICABLE) {
            console.warn('No applicable cell found.', uischema, schema);
            return null;
        }
        else {
            return (react_1.default.createElement("div", { className: classNames.wrapper, hidden: !visible, onFocus: this.onFocus, onBlur: this.onBlur, id: id },
                react_1.default.createElement("label", { htmlFor: id + '-input', className: classNames.label }, core_1.computeLabel(labelText, required, appliedUiSchemaOptions.hideRequiredAsterisk)),
                react_1.default.createElement(react_2.DispatchCell, { uischema: uischema, schema: schema, path: path, id: id + '-input' }),
                react_1.default.createElement("div", { className: divClassNames }, !isValid ? errors : showDescription ? description : null)));
        }
    };
    return InputControl;
}(react_2.Control));
exports.InputControl = InputControl;
exports.inputControlTester = core_1.rankWith(1, core_1.isControl);
exports.default = util_1.withVanillaControlProps(react_2.withJsonFormsControlProps(InputControl));
//# sourceMappingURL=InputControl.js.map